import React from 'react';

const Nutrition = () => {
  return (
      <div className="section" id="nutrition">
        <h2>Nutrition</h2>
      <div className="list-container">
        <div className="card">
          <h3>Vitamins / Supplements</h3>
          <p>Below is the key list of supplements I take and the frequency they are taken</p>
          <h4>Early Morning Empty Stomach</h4>
          <ul>
            <li>Pro Health NMN - 500mg Daily (DNA repair)</li>
            <li>Luma Nutrition High Purity Resveratrol - 600mg Daily (Take with NMN)</li>
          </ul>
          <h4>First Meal</h4>
          <ul>
            <li>365 Fish Oil - 1000mg EPA 180mg DHA 120mg Daily (Fat-soluble; with meal)</li>
            <li>Vital Proteins Collagen Peptides - Daily</li>
            <li>Pro Health Vitamin D3 & K2 with BioPerine - 125mcg 100mcg 2.5mg Daily (Fat-soluble vitamins; with meal)</li>
            <li>Plnt Men's 50+ multivitamin (Sa) (1 capsule on Saturday) </li>
          </ul>
          <h4>Afternoon Snack/Meal</h4>
          <ul>
            <li>365 Milk Thistle - 250mg Daily</li>
            <li>Pro Health Ubiquinol Coq10 - 100mg Daily (This dropped my heart range significantly)</li>
            <li>Pure Zinc - 15mg Daily (Skip multivitamin and D3/K2 days)</li>
            <li>Thorne B12 - 1mg Daily (Skip multivitamin and D3/K2 days)</li>
            <li>Life Extension PQQ - 10mg Daily</li>
          </ul>
          <h4>Last Meal</h4>
          <ul>
            <li>Kyolic Aged Garlic Extract Formula - 600mg Daily</li>
            <li>Qunol Tumeric - 1500mg (I take 1 pill 750mg with chicken or fish meals)</li>
          </ul>
          <h4>Pre or Post Workout</h4>
          <ul>
          <li>Om Mushroom Superfood, Master Blend Plant Protein, Creamy Vanilla (1 scoop 2 to 3 times a week)</li>
          <li>Puori 5g Creatine Monohydrate Powder with 400mg Taurine Daily</li>
          <li>EAMA Chios Gum mastic (2-3 days a week)</li>
          <li>Guru Nada Oil Pulling Oral Rinse (1-2 times a week at night)</li>
          </ul>
          <h4>Monthly Cycle</h4>
          <ul>
            <li>Pro Health Fisetin 250mg - (Take first 5 days of each month)</li>
          </ul>
          <h4>Pausing or <span style={{ textDecoration: 'line-through', color: 'red' }}>Removed</span></h4>
          <span style={{ textDecoration: 'line-through', color: 'red' }}>
          <ul>
            <li>Micronutrients Chlorella (or Spirulina) - 1000mg Daily (Pausing based on Viome recommendations)</li>
            <li>Thorne L-Theanine - 200mg Daily (Backing off for now as it may cause more harm to liver in a supplement)</li>
            <li>Melatonin - 2.5mg (Stopped as nose breathing seems to have improved sleep issues)</li>
            <li>Garden of Life Functional Protein Stress Relief (Doesn't feel healthy when drinking so I cut it)</li>
            <li>ForrestLeaf Red Yeast Rice with Coq10 (Su) - 1251mg/60mg (One day a week)</li>
          </ul>
        </span>


        </div>
        <div className="card">
          <h3>Regular Food</h3>
          <h4>Proteins</h4>
          <ul>
            <li>Calamari Tubes (1 to 2 times a month)</li>
            <li>Organic Wild Salmon (4 to 7 times a month)</li>
            <li>Edamame</li>
            <li>Eggs</li>
            <li>Mushrooms (Oyster, Portabella, and white) </li>
            <li>Plain Yogurt (Siggis) (I swap this with an Oatmeal mix sometimes - see recipes)</li>
            <li>Organic Tofu</li>
            <li>Wild Planet Canned Sardines (1 to 2 times a month)</li>
          </ul>
            <h4>Healthy Fats</h4>
          <ul>
            <li>Avocado</li>
            <li>Olive Oil (1 to 3x a day)</li>
            <li>Olives (Kalamata and Taggiasca)</li>
            <li>Organic Almonds</li>
            <li>Organic Brazil Nuts (Minimal)</li>
            <li>Organic Chia Seed</li>
            <li>Organic Flaxseed</li>
            <li>Organic Pine Nuts</li>
            <li>Organic Pumpkin seeds with Sea salt</li>
            <li>Organic Sunflower seeds</li>
  
          </ul>
            <h4>Complex Carbs</h4>
          <ul> 
            <li>Sweet Potatoes (Mostly Japanese)</li>
            <li>Organic Granola (High protein low sugar)</li>
            <li>Organic Kidney Beans</li>
            <li>Organic Black Beans</li>
            <li>Organic Pinto Beans</li>
            <li>Organic Chickpeas</li>
            <li>Lentils</li>
          </ul>
            <h4>Vegetables</h4>
          <ul>  
            <li>Arugula</li>
            <li>Beets</li>
            <li>Bok Choy</li>
            <li>Broccoli and Broccoli Sprouts</li>
            <li>Brussel Sprouts</li>
            <li>Cauliflower</li>
            <li>Cucumbers</li>
            <li>Kale</li>
            <li>Miso</li>
            <li>Organic Broccoli Sprouts</li>
            <li>Organic Bok Choy Sprouts</li>
            <li>Poblano Pepper</li>
          </ul>
            <h4>Antioxidant-Rich Foods</h4>
          <ul>  
            <li>Barberries (Dried)</li>
            <li>Blueberries</li>
            <li>Blackberries</li>
            <li>Cranberry Powder</li>
            <li>Cinnamon</li>
            <li>Cayenne Pepper</li>
            <li>Fortuna or Raaka Chocolate </li>
            <li>Ginger Powder</li>
            <li>Goji Berries (Dried)</li>
            <li>Kiwi</li>
            <li>Peaches</li>
            <li>Strawberries</li>
            <li>Tomatoes</li>
            <li>Tart Cherry Juice (Around 2oz at bedtime to help sleep)</li>
            <li>Tea (Dandylion, Ginger, Green, Hybiscus, Lemon and Mint)</li>
            <li>Coffee Black (daily and cut off at 10am or 11am)</li>
          </ul>
          <h4>Foods to Minimize or <span style={{ textDecoration: 'line-through', color: 'red' }}>Avoid</span></h4>
          <ul> 
            <li>Occasional Veggie Pizza</li> 
            <span style={{ textDecoration: 'line-through', color: 'red' }}>
            <li>Dried raw coconut</li>
            <li>Organic/Naked Chicken </li>
            <li>Organic Hemp Hearts (Nickel Impacting Oral Flagellar Pathways)</li>
            <li>Organic Pecans (Nickel Impacting Oral Flagellar Pathways)</li>
            <li>Bell Peppers (Microbiome plant virus infection related)</li>
            <li>Red Meat (Carnitine TMA production pathway)</li>
            <li>Pork (Carnitine TMA production pathway)</li>
            <li>Shrimp (Arginine Putrescine production pathway)</li>
            <li>Scallops (Nickel Impacting Oral Flagellar Pathways)</li>
            <li>Wild Planet Albacore Wild Tuna, Sea Salt, Canned Tuna (Tyrosine Uremic Toxin Pathways)</li>
            </span> 
          </ul>
        </div>
      </div>
      </div>
  );
};

export default Nutrition;